import axios from 'axios';
import config from '../config';

const url = config.apiUrl;

export const sendNotification = async ({ userId, transactionId, transition, uvk, metadata = {} }) => {
  try {
     await axios.post(`${url}/api/transaction-webhook`, {
      userId,
      transactionId: typeof transactionId === 'object' ? transactionId.uuid : transactionId,
      transition,
      uvk,
      metadata,
    });

  } catch (error) {

  }
};

// user_id: currentUser.attributes.publicData.shuUserId,
// booking_id:id,
// fleetNo: "SLK3368U"

export const sendShuCarPushConfig = async ({ user_id, booking_id, fleet_id }) => {
  try {
    let axiosConfig = {
      headers: {
          "Access-Control-Allow-Origin": "*"
      }
    };
    const res = await axios.post(`${url}/api/partner/grab/pushConfig`, {
      user_id,
      booking_id,
      fleet_id
    }, axiosConfig);
    return res.data;
  } catch (error) {

  }
};


export const startShuCar = async ({ user_id, booking_id, fleet_id }) => {
  try {
    let axiosConfig = {
      headers: {
          "Access-Control-Allow-Origin": "*"
      }
    };
    const res = await axios.post(`${url}/api/partner/grab/start`, {
      user_id,
      booking_id,
      fleet_id
    }, axiosConfig);
    return res.data;
  } catch (error) {

  }
};

export const lockShuCar = async ({ user_id, booking_id, fleet_id }) => {
  try {
    let axiosConfig = {
      headers: {
          "Access-Control-Allow-Origin": "*"
      }
    };
    const res = await axios.post(`${url}/api/partner/grab/lock`, {
      user_id,
      booking_id,
      fleet_id
    }, axiosConfig);
    return res.data;
  } catch (error) {

  }
};

export const unlockShuCar = async ({ user_id, booking_id, fleet_id }) => {
  try {
    let axiosConfig = {
      headers: {
          "Access-Control-Allow-Origin": "*"
      }
    };
    const res = await axios.post(`${url}/api/partner/grab/unlock`, {
      user_id,
      booking_id,
      fleet_id
    }, axiosConfig);
    return res.data;
  } catch (error) {

  }
};


export const stopShuCar = async ({ user_id, booking_id, fleet_id }) => {
  try {
    let axiosConfig = {
      headers: {
          "Access-Control-Allow-Origin": "*"
      }
    };
    const res = await axios.post(`${url}/api/partner/grab/stop`, {
      user_id,
      booking_id,
      fleet_id
    }, axiosConfig);
    return res.data;
  } catch (error) {

  }
};

export const getLockboxCode = async(listingId, isForce) => {
  try {
    let axiosConfig = {
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    const payload = isForce ? { listingId, isForce } : { listingId };
    const res = await axios.post(`${url}/api/sentrilock/generate-code-by-listing`, payload, axiosConfig);
    return res.data;
  } catch (error) {
    console.log(error)
    throw error
  }
}
